/**
 * Encapsulates the server interactions, and abstracts the API conventions
 */
import axios from 'axios'
import * as Sentry from '@sentry/browser'

const headers = {}
const http = axios.create({ headers })
const taskModule = {
  state: {
    runId: undefined,
    token: undefined,
    returnTo: undefined,
    task: undefined,
    workerId: undefined,
    key: undefined
  },
  getters: {
    identifiers (state) {
      return {
        run_id: state.runId,
        token: state.token,
        task: state.task,
        worker_id: state.workerId,
        key: state.key ? state.key : 'topx'
      }
    },
    returnTo (state) {
      return state.returnTo
    }
  },
  mutations: {
    init (state, { runId, token, returnTo, task, workerId, key }) {
      state.runId = runId
      state.token = token
      state.returnTo = returnTo
      state.task = task
      state.workerId = workerId
      state.key = key
    }
  },
  actions: {
    start ({ getters }) { // sets the start_time of the run
      return http.post(`${process.env.VUE_APP_ROOT_API}/notifications/`, { ...getters.identifiers, 'message': 'start' })
        // eslint-disable-next-line no-console
        // .catch(e => console.error(e.toString()))
        .catch(function (e) { console.error(e.toString()); Sentry.captureException(e) })
    },
    end ({ getters }, payload ) {
      // console.log(`result payload: ${JSON.stringify(payload)} getteras: ${JSON.stringify(getters.identifiers)}`)
      // sets the end_time of the run and passes a payload and paricipant info
      return (
        http.post(`${process.env.VUE_APP_ROOT_API}/notifications/`, {
          ...getters.identifiers,
          message: 'end',
          payload: Object.assign({payload}, {
            client_timestamp: Date.now()
          })
        })
          // eslint-disable-next-line no-console
          // .catch(function (e) { console.error(e.toString()); Sentry.captureException(e) })
          .catch(function (e) { console.error(e.toString()); Sentry.captureException(e) })
      )
    },
    // eslint-disable-next-line camelcase
    result ({ getters }, { action_type, payload }) { // logs a record in run_results with action_type, client_timestamp, and payload
      console.log(`result action: ${action_type}`)
      console.log(`result payload: ${JSON.stringify(payload)} getteras: ${JSON.stringify(getters.identifiers)}`)
      return http.post(`${process.env.VUE_APP_ROOT_API}/results/`, {
        ...getters.identifiers,
        'payload': Object.assign(payload, { 'action_type': action_type, 'client_timestamp': Date.now() })
        // action_type,
        // payload,
        // client_timestamp: Date.now()
      })
        // eslint-disable-next-line no-console
        // .catch(e => console.error(e.toString()))
        .catch(function (e) { console.error(e.toString()); Sentry.captureException(e) })
    },
    notify ({ state }, message) {
      return http.post(`${process.env.VUE_APP_ROOT_API}/notifications/`, { ...getters.identifiers, 'message': message })
        // eslint-disable-next-line no-console
        // .catch(e => console.error(e.toString()))
        .catch(function (e) { console.error(e.toString()); Sentry.captureException(e) })
    }
  }
}

export default taskModule
